import { Action, combineReducers } from '@ngrx/store';

import {
  _CLEAR,
  CREATE_HORIZON,
  DELETE_HORIZON,
  GET_HORIZONS,
  UPDATE_HORIZON
} from '../actions';

export function horizonListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_HORIZON:
      const match = state.find(horizon => action.payload.horizon && horizon.id === action.payload.horizon.id);
      return !match
        ? [ ...state, action.payload.horizon ].sort(sortHorizons)
        : state;
    case DELETE_HORIZON:
      return state.filter(horizon => horizon.id !== action.payload.id);
    case GET_HORIZONS:
      return action.payload.horizons.sort(sortHorizons);
    case UPDATE_HORIZON:
      return state.map(horizon => {
        return horizon.id === action.payload.horizon.id
          ? action.payload.horizon
          : horizon;
      });
    default:
      return state;
  }
}

const sortHorizons = (h1, h2) => {
  return +h1.id - +h2.id;
};

export const horizonReducers = combineReducers({
  horizonList: horizonListReducer
});


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/reducers/horizons.ts